import styles from "@css/modules/ResortSections.module.scss"
import { useMemo } from "react"

export function ProsCons({ items = [], title, color }) {
    const itemsToRender = useMemo(() => {
        let sum = 0
        return {
            items: items.map((i, index) => {
                sum += i.num
                return (
                    <li className={styles.prosConsItem} key={index}>
                        <div className={styles.prosConsLine}>
                            <span style={{ width: i.num + "%" }} />
                        </div>
                        {i.text}
                    </li>
                )
            }),
            sum,
            style: {
                "--color": color
            }
        }
    }, [items, color])
    if (!items.length) return null
    return (
        <div className={styles.prosConsRoot} style={itemsToRender.style}>
            <h4>{title}</h4>
            <div className={styles.prosConsLineMain}>
                <span style={{ width: itemsToRender.sum / itemsToRender.items.length + "%" }} />
            </div>
            <ul className={styles.prosConsList}>{itemsToRender.items}</ul>
        </div>
    )
}
